





















































































































import { Vue, Component } from "vue-property-decorator";
import shopItemRawDefinitions from "@/assets/shop-items-definitions.json";
import { ShopItemOptionDefinition } from "@/store/states/ShopState";
import { MetaInfo } from "vue-meta";

@Component<FAQ>({
  metaInfo(): MetaInfo {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      title: "SWISS ECO BAGS ™ | " + (this as any).$i18n.t("appbar.faq"),
      meta: [
        {
          vmid: "description",
          name: "description",
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          content: (this as any).$i18n.t("faq.description"),
        },
      ],
    };
  },
})
export default class FAQ extends Vue {
  get packagingPrice() {
    return shopItemRawDefinitions.prices.packaging;
  }

  get sendingPrice() {
    return shopItemRawDefinitions.prices.sending;
  }

  get minItems() {
    return shopItemRawDefinitions.quantities.min;
  }

  get maxItems() {
    return shopItemRawDefinitions.quantities.max;
  }

  get items(): ShopItemOptionDefinition {
    let result: ShopItemOptionDefinition = undefined;
    shopItemRawDefinitions.options.forEach((option) => {
      if (option.nameTranslationKey === "shop.option.bag.type") {
        result = option as ShopItemOptionDefinition;
      }
    });
    return result;
  }
}
